import React from "react";
import { SnackbarProvider } from "notistack";
import { Provider } from "react-redux";
import { Box } from "@material-ui/core";

import App from "./App";
import ThemeWrapper from "./ThemeWrapper";
import store from "./redux/store";

const notistackRef = React.createRef();
const onClickDismiss = (key) => () => {
  notistackRef.current.closeSnackbar(key);
};

export default function Root() {
  return (
    <Provider store={store}>
      <SnackbarProvider
        maxSnack={3}
        ref={notistackRef}
        action={(key) => (
          <Box
            style={{ color: "rgba(255, 255, 255, 0.8)", cursor: "pointer", padding: "0px 8px" }}
            onClick={onClickDismiss(key)}
          >
            Dismiss
          </Box>
        )}
      >
        <ThemeWrapper>
          <App />
        </ThemeWrapper>
      </SnackbarProvider>
    </Provider>
  );
}
